import { useId } from "react";

import { cn } from "@/lib/utils";

export default function NotFoundBg({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id1 = useId();
  const id2 = useId();
  const id3 = useId();
  const id4 = useId();
  const id5 = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn(
        "inline-block aspect-square h-auto w-full max-w-140",
        className
      )}
      fill="none"
      preserveAspectRatio="xMinYMin meet"
      viewBox="0 0 546 559"
      {...props}
    >
      <circle cx="492.573" cy="288.766" fill="#F7F7F7" r="6.51639" />
      <circle cx="466.614" cy="296.054" fill="#F7F7F7" r="4.3997" />
      <path
        d="M432.3 363.672L442.28 344.41L452.491 356.427L445.669 368.53C445.568 368.709 445.54 368.92 445.59 369.119L452.491 396.557C452.903 395.787 454.462 394.436 457.402 395.192C460.341 395.948 459.717 397.817 459.038 398.656C457.792 398.376 455.302 398.111 455.302 399.286C455.302 400.756 460.552 403.073 460.745 407.694C460.937 412.315 458.242 417.899 454.198 417.899C450.963 417.899 447.484 410.429 447.002 407.694L431.997 374.091C430.507 370.753 430.618 366.918 432.3 363.672Z"
        fill="#F3898A"
      />
      <rect
        fill="#F3898A"
        height="15.6665"
        width="11.5098"
        x="454.748"
        y="536.711"
      />
      <rect
        fill="#F3898A"
        height="15.6665"
        width="11.5098"
        x="496.13"
        y="536.711"
      />
      <path
        d="M493.858 404.13C481.434 401.174 449.304 404.13 449.304 404.13C444.876 443.908 448.959 521.536 452.271 544.819H468.068L473.018 442.728C479.174 463.791 487.794 522.672 492.909 544.819H509.447C509.447 544.819 506.282 407.085 493.858 404.13Z"
        fill="white"
      />
      <path
        clipRule="evenodd"
        d="M473.638 444.95L468.504 419.825L471.225 479.691L473.017 442.729C473.221 443.428 473.429 444.169 473.638 444.95Z"
        fill="#E6CFFF"
        fillRule="evenodd"
      />
      <path
        d="M497.281 408.878H448.966L449.717 401.846C464.103 400.925 492.21 400.148 492.947 400.475C493.683 400.802 496.565 406.935 497.281 408.878Z"
        fill="#4D0D54"
      />
      <rect
        fill="white"
        height="5.99389"
        width="1.97712"
        x="471.521"
        y="403.609"
      />
      <rect
        fill="white"
        height="5.99389"
        width="1.97712"
        x="486.248"
        y="403.609"
      />
      <path
        clipRule="evenodd"
        d="M468.074 322.602C468.074 322.595 468.074 322.589 468.074 322.582C467.576 322.802 466.971 323.025 466.269 323.283L466.269 323.283C461.083 325.188 450.559 329.056 438.038 348.557C438.912 352.344 442.233 360.385 448.526 362.249C449.259 360.967 450.07 359.615 450.933 358.21C448.124 376.143 447.984 395.859 448.689 404.375H498.643C498.643 388.169 499.57 372.884 500.934 360.262C504.475 364.506 508.233 368.78 510.422 371.212L524.156 355.179C516.177 342.878 509.45 332.673 502.568 327.508C494.194 320.48 478.34 318.051 468.074 322.602Z"
        fill={`url(#${id1})`}
        fillRule="evenodd"
      />
      <path
        d="M476.075 340.915L472.854 337.437L475.735 332.114L476.74 332.375L479.768 336.608L476.075 340.915Z"
        fill="#4D0D54"
      />
      <path
        d="M470.32 395.111L474.99 337.035L477.427 337.035V395.111L473.13 402.605L470.32 395.111Z"
        fill="#4D0D54"
      />
      <path
        d="M472.692 322.374C468.199 335.351 482.341 335.684 490.327 322.374V304.406H472.692V322.374Z"
        fill="#F3898A"
      />
      <path
        clipRule="evenodd"
        d="M472.692 317.614C472.756 317.932 472.824 318.259 472.897 318.596C474.684 326.854 485.122 318.043 490.159 313.609C490.217 313.562 490.273 313.514 490.327 313.467V310.275C487.71 308.769 480.958 308.207 475.547 307.756C474.614 307.678 473.722 307.604 472.897 307.529C472.83 307.551 472.761 307.592 472.692 307.653V317.614Z"
        fill="#CE5E60"
        fillRule="evenodd"
      />
      <path
        d="M472.073 380.714L481.166 387.545L487.147 392.039C488.866 393.33 489.213 395.77 487.922 397.488C486.63 399.207 484.19 399.554 482.472 398.263L476.491 393.769L467.397 386.938L472.073 380.714Z"
        fill="#BA3491"
      />
      <path
        d="M476.672 382.12L476.199 378.646L466.55 391.49L469.838 391.059C474.199 390.489 477.265 386.479 476.672 382.12Z"
        fill="#BA3491"
      />
      <ellipse
        cx="470.251"
        cy="384.213"
        fill="#BA3491"
        rx="3.81627"
        ry="8.65642"
        transform="rotate(36.9159 470.251 384.213)"
      />
      <ellipse
        cx="470.251"
        cy="384.214"
        fill={`url(#${id2})`}
        rx="2.94316"
        ry="7.2235"
        transform="rotate(36.9159 470.251 384.214)"
      />
      <path
        d="M462.658 381.065C463.425 381.546 464.793 380.748 465.712 379.282C466.632 377.816 466.756 376.237 465.989 375.756C465.704 375.577 381.677 150.039 369.916 142.412L142.924 7.27549e-06L0.00259281 227.805L226.995 370.217C238.403 378.405 462.374 380.886 462.658 381.065Z"
        fill={`url(#${id3})`}
      />
      <path
        clipRule="evenodd"
        d="M512.83 367.894L523.124 355.952L532.066 368.387C535.405 373.03 533.839 379.554 528.757 382.177L498.078 398.009C497.596 400.744 494.056 403.416 490.821 403.416C486.778 403.416 481.668 402.988 481.668 398.363C481.668 395.798 484.758 394.213 487.072 393.027C488.457 392.316 489.564 391.748 489.564 391.198C489.564 390.022 487.458 390.154 486.212 390.434C485.533 389.594 484.833 387.859 487.772 387.104C490.712 386.348 494.448 390.428 494.86 391.198L515.956 373.572C516.276 373.304 516.337 372.835 516.095 372.494L512.83 367.894Z"
        fill="#F3898A"
        fillRule="evenodd"
      />
      <path
        d="M480.613 340.49C496.653 326.828 492.824 319.123 490.337 317.252C488.467 324.555 478.947 331.189 476.507 332.374L480.613 340.49Z"
        fill="#6EC7F6"
      />
      <path
        d="M471.87 339.958L476.439 332.248C474.4 330.876 472.619 324.96 472.765 322.391V319.674C465.806 324.276 469.998 337.068 471.87 339.958Z"
        fill="#6EC7F6"
      />
      <path
        d="M465.942 296.803C465.942 289.547 468.596 285.034 475.853 285.034C483.109 285.034 492.221 289.547 492.221 296.803V304.112C492.221 311.369 486.338 317.252 479.081 317.252C471.825 317.252 465.942 311.369 465.942 304.112V296.803Z"
        fill="#F3898A"
      />
      <path
        d="M484.095 294.129C476.569 292.004 472.688 295.976 466.395 294.129C463.042 291.709 463.97 288.917 468.672 286.795C479.953 281.702 488.823 286.597 492.087 290.643C493.202 292.026 496.669 291.011 496.669 297.324C496.669 303.637 490.487 312.004 489.318 312.223C491.307 310.58 489.791 303.546 489.318 302.175C488.371 299.431 488.041 302.175 488.041 302.175C488.041 302.175 484.095 302.755 484.095 294.129Z"
        fill="#F7F7F7"
      />
      <path
        d="M465.925 302.718L465.925 295.523L463.991 293.329C464.097 298.378 465.421 301.6 465.925 302.718Z"
        fill="#F7F7F7"
      />
      <ellipse
        cx="490.126"
        cy="303.341"
        fill="#F3898A"
        rx="2.63895"
        ry="4.75687"
        transform="rotate(11.0883 490.126 303.341)"
      />
      <rect
        fill="white"
        height="5.99389"
        width="1.97712"
        x="454.79"
        y="403.609"
      />
      <path
        d="M433.086 556.402L454.922 547.481C459.105 551.297 462.719 549.216 465.288 547.7C466.086 547.229 467.721 547.481 467.721 547.481V558.809H433.559C432.187 558.809 431.817 556.921 433.086 556.402Z"
        fill={`url(#${id4})`}
      />
      <path
        d="M474.562 556.402L496.398 547.481C500.581 551.297 504.195 549.216 506.765 547.7C507.562 547.229 509.197 547.481 509.197 547.481V558.809H475.035C473.664 558.809 473.293 556.921 474.562 556.402Z"
        fill={`url(#${id5})`}
      />
      <circle cx="465.31" cy="288.23" fill="#F7F7F7" r="4.3997" />
      <circle cx="472.107" cy="282.85" fill="#F7F7F7" r="6.16447" />
      <circle cx="481.078" cy="281.085" fill="#F7F7F7" r="6.16447" />
      <circle cx="489.661" cy="285.109" fill="#F7F7F7" r="6.65865" />
      <ellipse
        cx="3.7145"
        cy="3.82377"
        rx="3.7145"
        ry="3.82377"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.41849"
        transform="matrix(-0.990086 -0.140463 -0.140463 0.990086 482.666 298.637)"
      />
      <ellipse
        cx="3.7145"
        cy="3.82377"
        rx="3.7145"
        ry="3.82377"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.41849"
        transform="matrix(-0.990086 -0.140463 -0.140463 0.990086 472.986 298.872)"
      />
      <path
        d="M472.132 300.576L474.761 300.603"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.41849"
      />
      <path
        d="M481.849 300.086L487.831 299.585"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.41849"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id1}
          x1="383.266"
          x2="498.633"
          y1="432.789"
          y2="443.778"
        >
          <stop stopColor="#43C9FF" />
          <stop offset="0.994792" stopColor="#586AFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id2}
          x1="466.947"
          x2="474.274"
          y1="391.437"
          y2="390.503"
        >
          <stop stopColor="#FAC118" />
          <stop offset="1" stopColor="#EF901B" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id3}
          x1="894.757"
          x2="-47.9595"
          y1="544.288"
          y2="217.182"
        >
          <stop offset="0.305226" stopColor="#FAC118" />
          <stop offset="0.819869" stopColor="#CE3494" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id4}
          x1="409.784"
          x2="453.965"
          y1="562.66"
          y2="575.429"
        >
          <stop stopColor="#43C9FF" />
          <stop offset="0.994792" stopColor="#586AFF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id5}
          x1="451.26"
          x2="495.441"
          y1="562.66"
          y2="575.429"
        >
          <stop stopColor="#43C9FF" />
          <stop offset="0.994792" stopColor="#586AFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
